import { RouteType } from "types/RouteType";
import { databaseDate } from "@intrasync/utils";
// import * as utils from '@intrasync/utils';
// import ReportsIcon from '@mui/icons-material/Assignment';

const productionReportRoute: RouteType[] = [
  {
    name: "Production Report",
    path: "/weekly-production-report/:castingDate",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Production Report",
        // component: () => import('./ProductionReport.Header'), // Assumed header component
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        component: () => import("./ProductionReport.Body"),
      },
    },
    defaultParams: { castingDate: databaseDate() },
    group: "Production",
    requiresAuth: true, // Implicitly requires auth if requiresPermission is true
    requiresPermission: false,
    // permissions: ['/app/weekly-production-report'], // Using permissions instead of permissionPath
    channels: ["panel-revit", "panel-plant", "panel-yard"],
    // beforeEnter: async ({ rootStore, params }) => {
    //   const {
    //     productionReportStore: { setDisplayDate },
    //     panelStore: { find: findPlantPanels },
    //     panelStore: { find: findRevitPanels },
    //   } = rootStore;
    //   const castingWeek = utils.getWeekDates(params.castingDate);
    //   setDisplayDate(params.castingDate);

    //   findPlantPanels({
    //     query: {
    //       castingDate: {
    //         $gte: castingWeek[0],
    //         $lte: castingWeek[castingWeek.length - 1],
    //       },
    //     },
    //   }).then((foundPlantPanels) => {
    //     const controlUUIDs = foundPlantPanels.data.map(
    //       (panel) => panel.controlUUID
    //     );
    //     findRevitPanels({ query: { controlUUID: { $in: [...controlUUIDs] } } });
    //   });
    // },
    // onParamsChange: async ({ rootStore, params }) => {
    //   const {
    //     productionReportStore: { setDisplayDate },
    //     panelStore: { find: findPlantPanels },
    //     panelStore: { find: findRevitPanels },
    //   } = rootStore;
    //   const castingWeek = utils.getWeekDates(params.castingDate);
    //   setDisplayDate(params.castingDate);
    //   findPlantPanels({
    //     query: {
    //       castingDate: {
    //         $gte: castingWeek[0],
    //         $lte: castingWeek[castingWeek.length - 1],
    //       },
    //     },
    //   }).then((foundPlantPanels) => {
    //     const controlUUIDs = foundPlantPanels.data.map(
    //       (panel) => panel.controlUUID
    //     );
    //     findRevitPanels({ query: { controlUUID: { $in: [...controlUUIDs] } } });
    //   });
    // },
  },
  // {
  //   name: 'Production Summary',
  //   path: '/weekly-production-report/production-summary/:castingDate',
  //   layout: '/app',
  //   viewportCard: {
  //     header: {
  //       title: 'Production Summary',
  //       component: () => import('./ProductionSummary.Header'), // Assumed header component
  //     },
  //     body: {
  //       component: () => import('./ProductionSummary.Container'),
  //     },
  //   },
  //   defaultParams: { castingDate: databaseDate() },
  //   requiresAuth: true, // Implicitly requires auth if requiresPermission is true
  //   requiresPermission: false,
  //   permissions: ['/app/weekly-production-report'], // Using permissions instead of permissionPath
  //   channels: ['job', 'job-plant', 'panel-revit', 'panel-plant', 'panel-yard'],
  //   beforeEnter: async ({ rootStore, params }) => {
  //     const {
  //       productionReportStore: { setDisplayDate },
  //       jobStore: { find: findJobs },
  //       jobStore: { find: findJobPlant },
  //       findAllStore: { findAllUpdates },
  //     } = rootStore;
  //     setDisplayDate(params.castingDate);
  //     findJobPlant();
  //     findJobs();
  //     findAllUpdates('panel-plant');
  //     findAllUpdates('panel-revit');
  //   },
  //   onParamsChange: async ({ rootStore, params }) => {
  //     const {
  //       productionReportStore: { setDisplayDate },
  //       jobStore: { find: findJobs },
  //       jobStore: { find: findJobPlant },
  //       findAllStore: { findAllUpdates },
  //     } = rootStore;
  //     setDisplayDate(params.castingDate);
  //     findJobPlant();
  //     findJobs();
  //     findAllUpdates('panel-plant');
  //     findAllUpdates('panel-revit');
  //   },
  // },
];

export default productionReportRoute;
